import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ILoginBody } from '@/types/auth.types';
import { AuthService } from '@/services/auth.services';

/**
 * Store d'authentification pour gérer login et infos utilisateur
 */
export const useAuthStore = defineStore('auth', () => {
  /**
   * Informations de l'utilisateur récupérées via getMeInfo
   * @type {Ref<any>}
   */
  const dataGetMeInfo = ref<any>(null);

  /**
   * Récupère les informations de l'utilisateur connecté
   * @returns {Promise<any>} Données de l'utilisateur
   */
  const getMeInfo = async (token?: string): Promise<any> => {
    const response = await AuthService.getMeInfo();
    dataGetMeInfo.value = response.data;
    return response.data;
  };

  /**
   * Effectue le login de l'utilisateur
   * @param {ILoginBody} data Objet contenant le user et le secret
   * @returns {Promise<any>} Réponse de l'API login
   */
  const login = async (data: ILoginBody): Promise<any> => {
    try {
      const response = await AuthService.login(data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return { dataGetMeInfo, getMeInfo, login };
});
